import $ from 'jquery';
import createComment from './create-comment';
import variant from './variant';

export default function () {
    createComment();
    variant();
    increaseCounter();
    decreaseCounter();
}

function increaseCounter()
{
    $('.js-increase').on('click', function(e){
        e.preventDefault();

        const currentCount = $('.js-qty-input').val();
        $('.js-qty-input').val(parseInt(currentCount) + 1);
    })
}

function decreaseCounter()
{
    $('.js-decrease').on('click', function(e){
        e.preventDefault();

        const currentCount = $('.js-qty-input').val();

        if(currentCount <=1)
        {   
            return;
        }
        $('.js-qty-input').val(parseInt(currentCount) -1 );
    })
}
